export default "__VITE_ASSET__cc645882__"